import type { EducationalAdvisorListVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveEducationalAdvisors = createApiThunk<EducationalAdvisorListVM, void>(
  "educationalAdvisors/retrieveEducationalAdvisors",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.educationalAdvisorList();
  },
);
